import React from "react";
import styled from "styled-components";
import theme from "../../../theme";
import Text from "../Text";

const RadioButtonLabel = styled.label(({ theme, disabled, marginInlineEnd, isRtl }) => ({
  position: "relative",
  right: isRtl && -20,
  left: !isRtl && -20,
  top: 6,
  width: 15,
  height: 15,
  borderRadius: "50%",
  background: theme.color.white,
  border: disabled ? `1px solid ${theme.color.gray}` : `1px solid ${theme.color.red}`,
  marginInlineEnd: marginInlineEnd ? marginInlineEnd : 0,
}));

const CustomLabel = styled(Text.Light)(({ $disabled }) => ({
  marginInlineEnd: 20,
  cursor: $disabled ? "default" : "pointer",
}));

const Wrapper = styled("div")(({ width }) => ({
  width: width || "100%",
  boxSizing: "border-box",
}));

const Item = styled("div")(() => ({
  display: "flex",
  alignItems: "start",
  boxSizing: "border-box",
  marginBottom: 15,
}));

const RadioButtonInput = styled.input`
  opacity: 0;
  z-index: 1;
  cursor: pointer;

  &:checked + ${Item} {
    background: ${theme.color.red};
    border: ${theme.color.red};
  }
  &:disabled {
    background: ${theme.color.gray};
    border: ${theme.color.gray};
    cursor: default;
  }
  &:checked + ${RadioButtonLabel} {
    background: ${theme.color.red};
    border: 1px solid ${theme.color.red};
    &::after {
      content: "";
      display: flex;
      border-radius: 50%;
      width: 15px;
      height: 15px;

      background: ${theme.color.red};
    }
  }
  &:disabled + ${RadioButtonLabel} {
    background: ${theme.color.gray};
    border: 1px solid ${theme.color.gray};
    cursor: default;
    &::after {
      content: "";
      display: flex;
      border-radius: 50%;
      width: 15px;
      height: 15px;

      background: ${theme.color.gray};
    }
  }
`;

const RadioButton = ({
  label,
  value,
  name,
  isRtl,
  select,
  handleSelectChange,
  disabled = false,
  marginInlineEnd,
  width,
  ...props
}) => {
  // The circle and the caption sit next to the (invisible) radio input and
  // select it on click, so they have to honour `disabled` themselves.
  const handleClick = () => {
    if (disabled) {
      return;
    }
    handleSelectChange({ target: { value: value } });
  };

  return (
    <Wrapper width={width}>
      <Item>
        <RadioButtonInput
          type="radio"
          name={name}
          value={value}
          checked={select === true}
          onChange={handleSelectChange}
          disabled={disabled}
        />
        <RadioButtonLabel
          isRtl={isRtl}
          disabled={disabled}
          marginInlineEnd={marginInlineEnd}
          onClick={handleClick}
        />
        <div onClick={handleClick}>
          <div
            style={{
              position: "relative",
              right: !isRtl ? -30 : -10,
              left: isRtl ? -30 : -10,
            }}
          >
            <CustomLabel name={props.name} $disabled={disabled}>
              {label}
            </CustomLabel>
          </div>
        </div>
      </Item>
    </Wrapper>
  );
};

export default RadioButton;
